<template>
  <div class="page-login">
    <!-- <img class="logos" src="../assets/img/loginicon.png" alt="" /> -->
    <div>
      <el-form :model="user" :rules="rules" ref="user" label-position="top" label-width="100px">
        <div v-if="flag1">
          <el-form-item label="" prop="account">
            <el-input type="text" v-model.trim="user.account" auto-complete="off" placeholder="输入账号"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <div style="margin-top: 15px;">
              <el-input type="password" v-model.trim="user.password" auto-complete="off" placeholder="输入密码"></el-input>
            </div>
          </el-form-item>
        </div>
        <div v-if="flag">
          <el-form-item label="" prop="mobile">
            <el-input type="text" v-model.trim="user.mobile" auto-complete="off" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item label="" prop="code">
            <div style="margin-top: 15px;">
              <el-input type="text" v-model.trim="user.code" auto-complete="off" placeholder="验证码">
                <template slot="append">
                  <span class="verification" v-show="!show" @click="getVerification('form')">获取验证码</span>
                  <span class="countdown" v-show="show"><span>{{countdown}}</span><span>秒后重试</span></span>
                </template>
              </el-input>
            </div>
          </el-form-item>
        </div>
        <div class="changeMode">
          <i class="el-icon-warning" style="margin-right:3px;margin-top:2px;"></i>
          <span @click="phoneLogin" v-if="flag1">手机号登录</span>
          <span @click="phoneLogin1" v-if="flag">账号登录</span>
        </div>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="login('user')" @keyup.enter="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        account: "",
        password: "",
        mobile: "",
        code: "",
      },
      flag: true,
      flag1: false,
      rules: {
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },],
        account: [{
          required: true,
          message: "请输入账号",
          trigger: "blur",
        },],
        mobile: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },],
        code: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },],
      },
      countdown: '',
      show: false,
      timer: null
    };
  },
  computed: {
    loading() { },
  },
  methods: {
    // 如果true，那么password填验证码，如果false，password填密码
    login(user) {
      // redirect ? router.replace(redirect) : router.replace("/");
      if (this.flag1 == true) {
        var data = {
          userName: this.user.account,
          password: md5(this.user.password),
          isCode: false,
        };
      } else if (this.flag == true) {
        var data = {
          password: this.user.code,
          mobile: this.user.mobile,
          isCode: true
        };
      }
      var redirect = this.$route.query.redirect;
      this.$refs.user.validate((valid) => {
        if (valid) {
          api.request("/employee/employeeLogin", data, function (res) {
            Lockr.set("skinToken", res.data.token);
            Lockr.set("skinUserName", res.data.userName);
            Lockr.set("skinEmpId", res.data.empId);
            Lockr.set("skinPermission", res.data.permission)
            Lockr.set("skinJurisdictionId", res.data.jurisdictionId)
            Lockr.set("skinJurisdictionName", res.data.jurisdictionName)
            Lockr.set("skinMobile", res.data.mobile)
            Lockr.set("instrumentLog", res.data.instrumentLog)
            Lockr.set("outpatientServiceLog", res.data.outpatientServiceLog)
            Lockr.set("leaveObserve", res.data.leaveObserve)
            window.axios.defaults.headers.token = Lockr.get("skinToken");
            redirect ? router.replace(redirect) : router.replace("/Home");
          });
        } else {
          return false;
        }
      })
    },
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        this.login(); // 定义的登录方法
      }
    },
    phoneLogin() {
      this.flag1 = false
      this.flag = true
      this.$refs.user.resetFields();
    },
    phoneLogin1() {
      this.flag1 = true
      this.flag = false
      this.$refs.user.resetFields();
    },
    // 获取验证码
    getVerification() {
      if (this.user.mobile == "" || !this.user.mobile) {
        _g.toast("warning", '手机号不能为空');
        return
      } else {
        // var Reg = /^[1][34578][0-9]{9}$/;
        // // 正则验证
        // if (Reg.test(this.user.mobile)) {
        if (!this.timer) {
          const TIME_COUNT = 60;
          this.countdown = TIME_COUNT;
          this.show = true
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              this.show = false
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }

        let data = {
          mobile: this.user.mobile
        }
        api.request("/employee/sendSms", data, (res) => {
          console.log(res)
          if (res.result == true) {
            _g.toast("success", '验证码发送成功');
          } else {
            _g.toast("error", res.data);
          }
        });
        // } else {
        //   _g.toast("warning", '手机号码格式不正确');
        // }
      }

    },
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style scoped>
.page-login {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: rgba(34, 34, 34, 0)
    linear-gradient(38deg, #622ec3 0%, #4d65db 29%, #379aee 69%, #53e9f6 100%);
  background-size: 100%;
}

.logos {
  width: 12%;
  max-width: 416px;
  max-height: 338px;
  height: 22%;
  display: block;
  margin: 0 auto;
  margin-top: 4%;
}

.page-login form {
  width: 80%;
  max-width: 586px;
  background: rgba(255, 255, 255, 0.15);
  padding: 60px 40px;
  margin: 250px auto;
  border-radius: 25px;
  border: 1px solid #ffffff;
  text-align: center;
}

.titimg {
  width: 425px;
  max-height: 168px;
  text-align: center;
}

input {
  max-width: 280px;
  border-radius: 50% !important;
}

.page-login form footer {
  font-size: 14px;
  color: #666;
  text-align: right;
  margin-top: -15px;
}

.page-login form button {
  width: 100%;
  margin-top: 10px;
}
.changeMode {
  /* float: right; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #c0c5ca;
  cursor: pointer;
  margin-bottom: 12px;
  font-size: 12px;
}
.verification {
  font-size: 0.75rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0364a8;
  margin-right: 3%;
  cursor: pointer;
}
</style>